/* ============================================================================
   money.js — Preisformatierung im Browser
   ----------------------------------------------------------------------------
   Frueher assets/nko-money.js (seit M6 umbenannt, Verhalten unveraendert).
   Ersetzt `theme.Currency.formatMoney` aus dem frueheren assets/scripts.js
   samt dessen Hilfsfunktion `theme.utils.defaultTo`.

   WER DAS LAEDT
   ---------------------------------------------------------------------------
   Nur, wer im Browser Preise rechnet (R5): snippets/product-bundles.liquid
   und snippets/product-gifts.liquid (Summen und Rabatte der Popups) sowie
   sections/customizable-product-info.liquid (Konfigurator). Jedes davon
   setzt ein eigenes <script type="module">; der Browser fuehrt die Datei je
   URL nur einmal aus. Die Kollektion und die uebrigen Produktseiten rechnen
   keine Preise im Browser — dort laedt die Datei nicht mehr.

   ZWEI NAMEN FUER DIESELBE FUNKTION
   ---------------------------------------------------------------------------
     window.NKO.formatMoney        neu, fuer die Module ab M6 (bundles.js,
                                   gifts.js) — §5.2: kleine geteilte
                                   Funktionen haengen an window.NKO
     window.theme.Currency         bleibt fuer die bestehenden Aufrufer
       .formatMoney                (assets/configurator.js)

   DAS VERHALTEN IST BEWUSST DAS DES LEGACY, inklusive der Eigenheiten:
     * `cents.replace('.', '')` entfernt bei einer Zeichenkette nur den ERSTEN
       Punkt. Der Shop liefert Cents als Zahl, der Zweig greift praktisch nie.
     * Unbekannte Platzhalter fallen auf `amount` zurueck. Frueher kannte die
       Funktion nur fuenf und ersetzte jeden anderen durch eine LEERE
       Zeichenkette — in SEK (`{{amount_with_space_separator}} kr`) stand in
       den Bundle- und Geschenk-Popups dann nur „ kr“. Alle Shopify-Platzhalter
       sind abgedeckt.
     * `formatString.match(...)` wirft, wenn gar kein Platzhalter enthalten ist.
   Ohne zweites Argument gilt `theme.settings.moneyFormat` (snippets/scripts.liquid,
   im Kopf, also immer vor diesem Modul da) — so rechnet /de-ch/ in CHF.
   `getBaseUnit` ist nicht mitgekommen; niemand ruft es auf.
   ==========================================================================  */

const STANDARD_FORMAT = "${{amount}}";
const PLATZHALTER = /\{\{\s*(\w+)\s*\}\}/;

function wert(v, ersatz) {
  // `v !== v` faengt NaN — genau wie theme.utils.defaultTo im Legacy.
  return v == null || v !== v ? ersatz : v;
}

function mitTrennern(zahl, nachkommastellen, tausender, dezimal) {
  nachkommastellen = wert(nachkommastellen, 2);
  tausender = wert(tausender, ",");
  dezimal = wert(dezimal, ".");

  if (isNaN(zahl) || zahl == null) return 0;

  const feste = (zahl / 100.0).toFixed(nachkommastellen);
  const teile = feste.split(".");
  const ganz = teile[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + tausender);
  const rest = teile[1] ? dezimal + teile[1] : "";

  return ganz + rest;
}

function formatMoney(cents, format) {
  if (!format) format = window.theme?.settings?.moneyFormat;
  if (typeof cents === "string") cents = cents.replace(".", "");

  const formatString = format || STANDARD_FORMAT;
  let value = "";

  switch (formatString.match(PLATZHALTER)[1]) {
    case "amount":
      value = mitTrennern(cents, 2);
      break;
    case "amount_no_decimals":
      value = mitTrennern(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = mitTrennern(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = mitTrennern(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = mitTrennern(cents, 0, " ");
      break;
    case "amount_with_space_separator":
      value = mitTrennern(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = mitTrennern(cents, 2, " ", ".");
      break;
    case "amount_with_apostrophe_separator":
      value = mitTrennern(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_period_separator":
      value = mitTrennern(cents, 0, ".");
      break;
    default:
      value = mitTrennern(cents, 2);
  }

  return formatString.replace(PLATZHALTER, value);
}

window.NKO = window.NKO || {};
window.NKO.formatMoney = formatMoney;

window.theme = window.theme || {};
window.theme.Currency = { formatMoney };

/* ----------------------------------------------------------------------------
   NUR ALS MODUL LADEN: <script src="…" type="module">, nie mit `defer`.
   Der Modulbereich haelt die Namen oben lokal; als klassisches Skript stiessen
   sie sich an denen anderer Theme-Dateien. Module laufen wie `defer` nach dem
   Parsen in Dokumentreihenfolge, aber nur einmal je URL und im strict mode.
   ---------------------------------------------------------------------------- */
